export enum OmsTriggerKey {
  NEW_FULFILLMENT_GROUP = "new_fulfillment_group",
  ORDER_READY_FOR_PICKUP = "order_ready_for_pickup",
  LABEL_PURCHASED = "label_purchased",
  FULFILLMENT_LABEL_PURCHASED = "fulfillment_label_purchased",
  PACKING_SLIP_PRINTED = "packing_slip_printed",
  SCAN_VERIFY_OPENED = "scan_verify_opened",
  ADDRESS_VERIFICATION_FAILED = "address_verification_failed",
  WORK_ORDER = "work_order",
}
